import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SpinnyService } from '../spinny/spinny.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthInteceptor implements HttpInterceptor {
  constructor(private router: Router, private spinnyService: SpinnyService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.spinnyService.showSpinny();
    if (localStorage.getItem('access_token')) {
      const accessToken = localStorage.getItem('access_token');
      const clone = req.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json'
        }
      });
      return next.handle(clone).pipe(
        tap(
          event => {
            if (event instanceof HttpResponse) {
              this.spinnyService.hideSpinny();
            }
          },
          error => {
            this.spinnyService.hideSpinny();
            if (error.status === 401) {
              localStorage.removeItem('user');
              this.router.navigate(['/authentication/login']);
              return Observable.throw(error);
            }
          }
        )
      );
    } else {
      return next.handle(req).pipe(
        tap(
          event => {
            if (event instanceof HttpResponse) {
              this.spinnyService.hideSpinny();
            }
          },
          error => {
            this.spinnyService.hideSpinny();
            if (error.status === 401) {
              localStorage.removeItem('user');
              this.router.navigate(['/authentication/login']);
              return Observable.throw(error);
            }
          }
        )
      );
    }
  }
}
